<script lang="ts">
  /**
   *
   * App.svelte
   *
   * Desc : Page. Application svelte
   *
   * Author : Sebastien Hoarau, Dmytro Teliakovskyi, Nicolas Galois
   *
   * Project : Cocolake
   *
   */

  
  // Components
  import Authentication from "./modules/authentication/presentation/page/Authentication.svelte";
  import Errors from "./Errors.svelte";
  import CVSearch from "./modules/cvSearch/presentation/page/CVSearch.svelte";
  import CVResult from "./modules/cvResult/presentation/page/CVResult.svelte";
  import CVDisplay from "./modules/cvResult/presentation/page/CVDisplay.svelte";

  // Utils
  import { routePath } from "./helpers/Navigation";
  import RootRedirect from "./lib/RootRedirect.svelte";

  
</script>

<main>
  {#key $routePath}
    {#if $routePath === "/"}
      <RootRedirect />
    {:else if $routePath === "/auth"}
      <Authentication />
    {:else if $routePath === "/search"}
      <CVSearch />
    {:else if /^\/result\/[^/]+\/?$/.test($routePath)}
      <CVResult />
    {:else if /^\/display\/[^/]+\/?$/.test($routePath)}
      <CVDisplay />
    {:else}
      <Errors />
    {/if}
  {/key}
</main>

<style lang="scss">
  main {
    min-height: 100vh;
    position: relative;
    overflow: hidden;
    background: #0a0a0a;
  }
</style>
